var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer-logo-youtube 1",
    clipPath: "url(#clip0_45_191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2874 4.57031H5.71596C3.19123 4.57031 1.14453 6.61701 1.14453 9.14174V22.856C1.14453 25.3808 3.19123 27.4275 5.71596 27.4275H26.2874C28.8121 27.4275 30.8588 25.3808 30.8588 22.856V9.14174C30.8588 6.61701 28.8121 4.57031 26.2874 4.57031Z",
    stroke: "black",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.141 21.3028V11.7028C12.1362 11.5407 12.1758 11.3804 12.2553 11.2391C12.3349 11.0979 12.4515 10.981 12.5926 10.901C12.7336 10.8211 12.8938 10.7811 13.0559 10.7855C13.218 10.7898 13.3759 10.8383 13.5124 10.9257L21.741 15.7257C21.8785 15.8063 21.9925 15.9215 22.0717 16.0599C22.1509 16.1982 22.1926 16.3548 22.1926 16.5142C22.1926 16.6736 22.1509 16.8303 22.0717 16.9686C21.9925 17.1069 21.8785 17.2221 21.741 17.3028L13.5124 22.1028C13.3728 22.1834 13.2144 22.2257 13.0532 22.2253C12.892 22.225 12.7338 22.182 12.5946 22.1008C12.4553 22.0196 12.3401 21.903 12.2604 21.7628C12.1807 21.6227 12.1396 21.464 12.141 21.3028Z",
    stroke: "black",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.74159db83d730b94171835a9b3260797.svg";
export { ForwardRef as ReactComponent };